// TOUR-10 — Documents Editor walkthrough (documents + proposal presets).

import type { FireflyTourArtifact } from "../tourTypes";

export const FORMS_FORMATS_TOUR_ID = "tour-forms-formats";

export const FORMS_FORMATS_TOUR: FireflyTourArtifact = {
  id: FORMS_FORMATS_TOUR_ID,
  version: 2,
  defaultIntent: "teaching",
  intents: [
    "documents editor tour",
    "documents editor",
    "forms and formats tour",
    "forms and formats",
    "edit proposal template",
    "custom pdf preset",
    "proposal format tour",
    "how do i edit proposal copy",
    "forms formats walkthrough",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer", "admin"],
  steps: [
    {
      id: "nav-forms-formats",
      target: {
        mode: "formsAndFormats",
        anchorId: "mode-nav-formsAndFormats",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "formsAndFormats",
      copy: {
        title: "Open Documents Editor",
        body: "Org documents and proposal PDF presets live here under Manager. Tap Documents Editor in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "ff-surface",
      target: { mode: "formsAndFormats", anchorId: "ff-surface", scrollIntoView: true },
      copy: {
        title: "Four authoring lanes",
        body: "Documents hosts your org form library and inline editor. Proposals configures PDF copy and calculations per product type. Asset library stores reusable images.",
      },
      advanceOn: "next_button",
    },
    {
      id: "documents-tab",
      target: { mode: "formsAndFormats", anchorId: "ff-documents-tab", scrollIntoView: true },
      copy: {
        title: "Documents tab",
        body: "Browse by category, fill and export PDFs, or use Add New / Edit Form to author templates.",
      },
      waitForClick: true,
    },
    {
      id: "proposals-tab",
      target: { mode: "formsAndFormats", anchorId: "ff-proposals-tab", scrollIntoView: true },
      copy: {
        title: "Proposals tab",
        body: "Switch to Proposals to edit PDF presets — cover letter, cost breakdown, deposit rules, and payment milestones.",
      },
      waitForClick: true,
    },
    {
      id: "proposal-preset-list",
      target: {
        mode: "formsAndFormats",
        anchorId: "ff-proposal-preset-list",
        scrollIntoView: true,
      },
      copy: {
        title: "Product type presets",
        body: "Pick a product type from your org catalog, or Generic for the fallback template. Each tab holds its own overrides.",
      },
      advanceOn: "next_button",
    },
    {
      id: "proposal-text-editor",
      target: {
        mode: "formsAndFormats",
        anchorId: "ff-proposal-text-editor",
        scrollIntoView: true,
      },
      copy: {
        title: "Proposal text sections",
        body: "Edit cover letter and related sections per tab. Toggle inclusion, tweak copy, and revert to defaults when needed.",
      },
      advanceOn: "next_button",
    },
    {
      id: "proposal-save",
      target: { mode: "formsAndFormats", anchorId: "ff-proposal-save", scrollIntoView: true },
      copy: {
        title: "Save overrides",
        body: "Save persists org-scoped text for the selected product type. Reps see the updated copy on the next proposal PDF.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "formsAndFormats", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Custom org documents live on the Documents tab here. Ask Firefly anytime for opportunities or capture tours from Sales modes.",
      },
      advanceOn: "next_button",
    },
  ],
};
